export function isProcoreStaging(): boolean {
    return window.location.hostname.endsWith("procoretech-qa.com");
}
